export default __webpack_public_path__ + "static/media/elumnt721.1d66abb6.sol";